/**
 * Layer Providers
 *
 * This file exports all available layer providers to make them easily accessible.
 */

import { WeatherLayerProvider } from './WeatherLayerProvider';
import { AffLayerProvider } from './AffLayerProvider';
import { SmokeLayerProvider } from './SmokeLayerProvider';

// Lazy singleton instances - initialized on first access to ensure config is loaded
let _weatherLayerProvider: WeatherLayerProvider | null = null;
let _affLayerProvider: AffLayerProvider | null = null;
let _smokeLayerProvider: SmokeLayerProvider | null = null;

export const getWeatherLayerProvider = (): WeatherLayerProvider => {
  if (!_weatherLayerProvider) {
    _weatherLayerProvider = new WeatherLayerProvider();
  }
  return _weatherLayerProvider;
};

export const getAffLayerProvider = (): AffLayerProvider => {
  if (!_affLayerProvider) {
    _affLayerProvider = new AffLayerProvider();
  }
  return _affLayerProvider;
};

export const getSmokeLayerProvider = (): SmokeLayerProvider => {
  if (!_smokeLayerProvider) {
    _smokeLayerProvider = new SmokeLayerProvider();
  }
  return _smokeLayerProvider;
};

// Export provider classes as well in case custom instances are needed
export {
  WeatherLayerProvider,
  AffLayerProvider,
  SmokeLayerProvider,
};